import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import StarsModal from '@swf/components/StarsModal/StarsModal';
import StarsWidget from '@swf/components/StarsWidget/StarsWidget';
import type { Dispatch } from '@swf/core/store';
import type { StaticContext } from '@swf/core/types/StaticContext';

export const headerWidgetProps = {
  type: 'HeaderWidget' as const,
  id: 'headerWidget/c986133b',
  config: {},
  meta: { name: 'Header Widget' }
};

const FirstCMSHeader: React.FC = () => {
  const staticContext: StaticContext = {};
  const dispatch = useDispatch<Dispatch>();
  const [headerPreloaded, setHeaderPreloaded] = useState(!!dispatch[headerWidgetProps.id]);

  staticContext.prefetch = async ({ dispatch }) => {
    await Promise.all([
      await dispatch.page.prepareWidget(headerWidgetProps),
      await dispatch.page.loadWidget(headerWidgetProps)
    ]);
  };

  useEffect(() => {
    const fetchHeaderData = async () => {
      await Promise.all([
        await dispatch.page.prepareWidget(headerWidgetProps),
        await dispatch.page.loadWidget(headerWidgetProps)
      ]);
    };

    if (!headerPreloaded) {
      fetchHeaderData().then(() => setHeaderPreloaded(true));
    }
  }, [dispatch.page, headerPreloaded]);

  return (
    <>
      {headerPreloaded && <StarsWidget {...headerWidgetProps} />}
      {headerPreloaded && <StarsModal />}
    </>
  );
};

export default FirstCMSHeader;
